/***************************************************************
8/2/2019
Alexander Self
solutions_table.js
- Displays a list of chemical solutions
***************************************************************/
import FabModal from './fab_modal';
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  chemicalList: PropTypes.array,
  chemicalApplications: PropTypes.array,
  readOnly: PropTypes.bool
};

const ChemicalApplicationTable = ({ chemicalApplications, chemicalList, employees, readOnly, centered,
  selectedApp, selectApplicationToView }) => {
  if (!chemicalApplications) return <span></span>;
  if (!employees) return <span></span>;
    return (
    <table className="bordered highlight responsive-table centered chem-app-table">
      <thead>
        <tr className="chem-app-table-headers">
          <th>Date</th>
          <th>Field</th>
          <th>Employee</th>
          <th>Start Time</th>
          <th>End Time</th>
          <th>Hours</th>
          <th>Acres Completed</th>
          <th>Acres Balance</th>
          <th>Status</th>
          <th>Products</th>
          <th>Round</th>
          <th>REI</th>
          <th>Pre-Harvest</th>
          { readOnly ? <th></th> : <th>Actions</th> }
        </tr>
      </thead>
      <tbody>
        {
          chemicalApplications.map((s, i) => {
            let chems = s.solutions.map((sols) => sols.chemId);
            let c = [];
            c = chems.map((chemId) => { return chemId === '' ? '' : chemicalList.find((cl) => cl.id === Number(chemId)) });
            if (c === undefined || c[0] === undefined) c = [];
            let name = 'N/A';
            let emp = {};
            if (employees.length > 0 && s.employee !== undefined) {
              emp = employees.find((e) => e.eid === s.employee);
              if (emp) name = `${ emp.firstName[0] }. ${ emp.lastName }`;
            }
            return (
              <tr className="chem-app-table-row" key={s.id}>
                <td>{ moment(s.date).format('MM/DD/YYYY') }</td>
                <td>{ s.fieldId }</td>
                <td>{ name }</td>
                <td>{ s.startTime }</td>
                <td>{ s.endTime }</td>
                <td>{ s.hours }</td>
                <td>{ s.acresCompleted }</td>
                <td>{ s.acresBalance < 0 ? <span className="red-text">{ s.acresBalance }</span> : <span>{ s.acresBalance }</span> }</td>
                <td>
                   { s.isComplete === 0 || s.isComplete === '0' ? <span className="label label-incomplete">Incomplete</span>
                      : <span className="label label-complete">Complete</span>
                   }
                </td>
                <td>{ c.length > 0 ? c.map((chem) => (<span className="chem-app-table-name" key={`${Math.random()}${chem.id}`}>{ chem.name }<br /></span>)) : '' }</td>
                <td>{ s.round }</td>
                <td>{ s.reiDaysRemaining } days</td>
                <td>{ s.preHarvestDaysRemaining } days</td>
                <td>{ readOnly ? ''
                  : <FabModal key={s.id} chem={s} chemicalList={chemicalList} selectApplicationToView={selectApplicationToView}
                      selectedApp={selectedApp}
                    />
                    }
                </td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  )
};

ChemicalApplicationTable.propTypes = propTypes;
export default ChemicalApplicationTable;



// WEBPACK FOOTER //
// ./src/cultivation/components/chem_app/chem_app_table.js